#import "../fragments/wf-form-fragment.graphql"

mutation UpdateWfForm($input: FormUpdateInput!) {
    formUpdate(input: $input) {
        form {
            ...WfFormFragment
        }
    }
}
